import * as TabsPrimitive from '@radix-ui/react-tabs'

import { cn } from '@/lib/utils'

/**
 * Thin styled wrapper around Radix's Tabs primitive (M7, first used by
 * `BatchDialog`'s Edit/Export split) -- per this project's rule to use
 * Radix for complex interactive components (focus management, keyboard
 * arrow-key navigation between tabs, and ARIA `tab`/`tabpanel` roles are
 * all handled by the primitive, not hand-rolled here).
 */
export const Tabs = TabsPrimitive.Root

export function TabsList({ className, ...props }: TabsPrimitive.TabsListProps) {
  return (
    <TabsPrimitive.List className={cn('border-border flex gap-1 border-b', className)} {...props} />
  )
}

export function TabsTrigger({ className, ...props }: TabsPrimitive.TabsTriggerProps) {
  return (
    <TabsPrimitive.Trigger
      className={cn(
        'text-muted-foreground hover:text-foreground focus-visible:ring-ring data-[state=active]:border-primary data-[state=active]:text-foreground -mb-px border-b-2 border-transparent px-3 py-1.5 text-sm font-medium outline-none focus-visible:ring-2',
        className,
      )}
      {...props}
    />
  )
}

export function TabsContent({ className, ...props }: TabsPrimitive.TabsContentProps) {
  return <TabsPrimitive.Content className={cn('pt-3', className)} {...props} />
}
